module.exports = __webpack_public_path__ + "static/media/student.e7395199.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/student.webp
// module id = 542
// module chunks = 4